import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import client from "graph-ql";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.less";
import "moment/locale/es";
import esES from "antd/lib/locale/es_ES";
import theme from "config/theme";
import { UserProvider } from "providers/user";
import "./index.css"; // General styles
import "./custom.less"; // Custom icon styles

ConfigProvider.config({
  primaryColor: "#65B992",
  errorColor: "#ff4d4f",
  warningColor: "#faad14",
  successColor: "#52c41a",
  infoColor: "#1890ff",
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <UserProvider>
          <ConfigProvider locale={esES}>
            <App />
          </ConfigProvider>
        </UserProvider>
      </Router>
    </ThemeProvider>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
